import { Package, RefreshCw, Clock } from 'lucide-react';

export default function RefundReturn() {
  return (
    <div className="refund-return-page">
      <div className="refund-return-container">
        {/* Header */}
        <div className="refund-return-header">
          <h1>Refund & Return Policy</h1>
          <p>Learn about our hassle-free return and refund process.</p>
        </div>

        {/* Quick Info Cards */}
        <div className="refund-return-cards">
          <div className="refund-return-card">
            <Clock className="refund-return-card-icon" />
            <h3>30-Day Returns</h3>
            <p>Return items within 30 days of delivery</p>
          </div>

          <div className="refund-return-card">
            <RefreshCw className="refund-return-card-icon" />
            <h3>Easy Process</h3>
            <p>Simple and hassle-free return process</p>
          </div>

          <div className="refund-return-card">
            <Package className="refund-return-card-icon" />
            <h3>Full Refund</h3>
            <p>Get your money back within 5-7 days</p>
          </div>
        </div>

        {/* Content */}
        <div className="refund-return-content">
          <section className="refund-return-section">
            <h2>Return Policy</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            <ul className="refund-return-list">
              <li>Items must be in original condition</li>
              <li>Include all tags and packaging</li>
              <li>Provide proof of purchase</li>
              <li>Return within 30 days of delivery</li>
            </ul>
          </section>

          <section className="refund-return-section">
            <h2>Refund Process</h2>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </section>

          <section className="refund-return-section">
            <h2>Non-Returnable Items</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <ul className="refund-return-list">
              <li>Opened or used products</li>
              <li>Items without original packaging</li>
              <li>Final sale items</li>
              <li>Custom or personalized orders</li>
            </ul>
          </section>

          <section className="refund-return-section">
            <h2>How to Return</h2>
            <p>
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <ol className="refund-return-list">
              <li>Contact our support team</li>
              <li>Receive return authorization</li>
              <li>Pack items securely</li>
              <li>Ship to provided address</li>
              <li>Receive refund confirmation</li>
            </ol>
          </section>

          <section className="refund-return-section">
            <h2>Exchanges</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </section>

          <section className="refund-return-section">
            <h2>Contact Us</h2>
            <p>
              For return and refund inquiries, please contact us at returns@example.com or call +1 (234) 567-8900
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}